import './vacatures-slider.scss';
import { bootstrapOverlappingSliders } from '@/js/lib/overlap-slider.js';

// Zelfde slider-werking als het collega-block (gedeelde lib). De vacatures-
// slider draait in vlakke modus (data-overlap="false" in vacatures-slider.php).
// De bootstrap is idempotent, dus dubbel aanroepen (collegas.js doet dat ook)
// is veilig.
bootstrapOverlappingSliders();
